import ComplexComponentsDemo from '../components/ComplexComponentsDemo'

function DesigningPage() {
  return <ComplexComponentsDemo />
}

export default DesigningPage
